import PrintProductConfiguratorControlsPane from './PrintProductConfiguratorControlsPane';

export default PrintProductConfiguratorControlsPane;
